import { ComposeIdealOrderParams } from "view/apps/Exhibitor/pages/Cart/helpers/composeOrderFileds/types";
import { IdealOrder, OrderStatus } from "ts/api/order";
import { mapOrderProduct } from "view/apps/Exhibitor/pages/Cart/helpers/mapOrderProduct";
import { PaymentMethodType } from "ts/api/paymentMethod";
import getTransfers from "tools/order/getTransfers";

const composeIdealOrder = async ({
  show,
  organiser,
  transferredPaymentDescription,
  products,
  createdAt,
  paymentType,
  exhibitorId,
  standId,
  billingDetails,
  totalAmount,
  isQuick,
  allowBankTransfer,
  id,
  orderGroupId,
  exhibitorPairId,
}: ComposeIdealOrderParams) => {
  const orderBase: Omit<
    IdealOrder,
    "paymentDetails" | "products" | "transfers" | "organiserRevenue"
  > = {
    createdAt,
    paymentType,
    exhibitorId,
    standId,
    billingDetails,
    id,
    orderGroupId,
    ...(isQuick && { allowBankTransfer: !!allowBankTransfer }),
  };

  const transfers = await getTransfers({
    products,
    show,
    transferredPaymentDescription,
    organiser,
    orderId: id,
  });

  const organiserRevenue = transfers[0].amount;
  const order: IdealOrder = {
    ...orderBase,
    exhibitorPairId,
    transfers,
    organiserRevenue,
    products: products.map((product) =>
      mapOrderProduct(product, PaymentMethodType.idealPayment)
    ),
    paymentDetails: {
      amount: totalAmount,
      status: OrderStatus.processing,
    },
    isQuick,
  };
  return order;
};

export default composeIdealOrder;
